'use client';

export { default } from './SwipeableDrawer';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/SwipeableDrawer/index.js
// module id = 961
// module chunks = 25